<template>
  <transition name="fade">
    <div
      v-if="notification.isVisible"
      class="fixed bottom-20 py-5 left-10 md:left-20 bg-primary text-app-color w-284 max-w-full mx-auto rounded-6 z-9999 shadow-notify"
    >
      <div class="flex items-start justify-between pl-15">
        <div class="flex">
          <i v-if="notification.color === 'success'" class="icon-check-circle text-app-color text-20 pt-13 pb-12 pr-10" />
          <i v-if="notification.color === 'error'" class="icon-warning text-app-color text-18 py-13 pr-10" />
          <!-- eslint-disable-next-line vue/no-v-html -->
          <p class="py-10" v-html="notification.message" />
        </div>
        <i
          class="icon-close cursor-pointer text-14 p-15 pt-16"
          @click="setNotification({ isVisible: false, message: '', color: '' })"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'NotificationModule',

  /* COMPUTED */
  computed: {
    ...mapState({
      notification: state => state.general.notification
    })
  },

  /* METHODS */
  methods: {
    ...mapMutations(['setNotification'])
  }
}
</script>
